/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPartI
 */
export interface ExecRiskPartI {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartI
     */
    ack_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartI
     */
    ack_id_uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPartI
     */
    row_order?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartI
     */
    small_plan_transfer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartI
     */
    small_plan_transfer_ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPartI
     */
    small_plan_transfer_pn?: string;
}

/**
 * Check if a given object implements the ExecRiskPartI interface.
 */
export function instanceOfExecRiskPartI(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPartIFromJSON(json: any): ExecRiskPartI {
    return ExecRiskPartIFromJSONTyped(json, false);
}

export function ExecRiskPartIFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPartI {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ack_id': !exists(json, 'ack_id') ? undefined : json['ack_id'],
        'ack_id_uuid': !exists(json, 'ack_id_uuid') ? undefined : json['ack_id_uuid'],
        'row_order': !exists(json, 'row_order') ? undefined : json['row_order'],
        'small_plan_transfer_name': !exists(json, 'small_plan_transfer_name') ? undefined : json['small_plan_transfer_name'],
        'small_plan_transfer_ein': !exists(json, 'small_plan_transfer_ein') ? undefined : json['small_plan_transfer_ein'],
        'small_plan_transfer_pn': !exists(json, 'small_plan_transfer_pn') ? undefined : json['small_plan_transfer_pn'],
    };
}

export function ExecRiskPartIToJSON(value?: ExecRiskPartI | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ack_id': value.ack_id,
        'ack_id_uuid': value.ack_id_uuid,
        'row_order': value.row_order,
        'small_plan_transfer_name': value.small_plan_transfer_name,
        'small_plan_transfer_ein': value.small_plan_transfer_ein,
        'small_plan_transfer_pn': value.small_plan_transfer_pn,
    };
}

